import { ReactElement } from "react";
import { FeedCardContextMenuItem } from "src/components/feed-card/context-menu/feed-card-context-menu-item";
import { useUnderlyingFollowStore } from "src/stores/uderlying-follow-store";
import { useWikifolioStore } from "src/stores/wikifolio-store";
import { IFeedCardProps } from "../feed-card";
import { EnumTaggedEntityType } from "../types/enums";
import { TFeedCardTaggedEntity } from "../types/feed-card";

export const useCreateContextMenuProps = ({
    showContextMenu,
    contextMenuItems,
    taggedEntities,
}: Pick<IFeedCardProps, "showContextMenu" | "contextMenuItems" | "taggedEntities">) => {
    const filterEnableTaggedEntities = useFilterEnableTaggedEntities();

    if ((showContextMenu && contextMenuItems) || !taggedEntities?.length) {
        return {
            createdContextMenuItems: contextMenuItems,
            createdShowContextMenu: showContextMenu,
        };
    }

    const enabledTaggedEntities = filterEnableTaggedEntities(taggedEntities);

    const createdContextMenuItems: ReadonlyArray<ReactElement> | undefined = enabledTaggedEntities.map(entity => (
        <FeedCardContextMenuItem key={entity.entityType + entity.entityId} taggedEntity={entity} />
    ));
    const createdShowContextMenu = Boolean(createdContextMenuItems?.length);

    return {
        createdContextMenuItems,
        createdShowContextMenu,
    };
};

const useFilterEnableTaggedEntities = () => {
    const { canBeFollowedWikifolios } = useWikifolioStore();
    const { canBeFollowedUnderlyingIsins } = useUnderlyingFollowStore();

    return (taggedEntities: ReadonlyArray<TFeedCardTaggedEntity>) =>
        taggedEntities.filter(({ entityType, entityId }) => {
            switch (entityType) {
                case EnumTaggedEntityType.Wikifolio:
                    return Boolean(canBeFollowedWikifolios[entityId]);
                case EnumTaggedEntityType.Underlying:
                    return canBeFollowedUnderlyingIsins.includes(entityId);
                case EnumTaggedEntityType.Comment:
                    return true;
                default:
                    return filterUnsupportedTaggedEntityType({ entityType });
            }
        });
};

const filterUnsupportedTaggedEntityType = ({}: { entityType: never }) => false;
